//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../Routing/Routing.PathStockBuilder.js";
import "../no/Expression.js";
let d=[[[0,"FlipStock",1,0],[0,"GridTopologyEligibilityFlag",1,0],[0,"RemoveExistingStock",1,0],[1,"RotationValue",0,"Expression",0],[1,"SegmentCollector",0,"Routing.RouteObjectCollector",0],[0,"StockAnchor",1,0],[0,"StockSettings",1,"Routing.PathStockBuilder",0],[0,"StockStyle",1,0],[0,"SwapProfile",1,0]],[],[]];
SPLM.Routing.StockBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.StockBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.StockBuilder.StockStyleType = Object.freeze({
    "Centerline" : "Centerline", "SimpleSolid" : "SimpleSolid", "DetailedSolid" : "DetailedSolid"});

export default SPLM;